import { render } from "./ClubProductList.vue?vue&type=template&id=6232d715&scoped=true&ts=true"
import script from "./ClubProductList.vue?vue&type=script&lang=ts"
export * from "./ClubProductList.vue?vue&type=script&lang=ts"

import "./ClubProductList.vue?vue&type=style&index=0&id=6232d715&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6232d715"]])

export default __exports__